import React from "react";

export const CircleIcon = (props:React.SVGProps<SVGSVGElement> & {size?:number|string}) => (
  <svg {...props} width={props.width || props.size || 30} height={props.height || props.size || 30} viewBox="0 0 50 50" fill={props.fill || "none"} xmlns="http://www.w3.org/2000/svg">
    <path d="M37.5 25a15.63 15.63 0 1 1-31.25 0 15.63 15.63 0 0 1 31.25 0z" stroke={props.color ? props.color : "CurrentColor"} strokeWidth={props.strokeWidth || "3"}/>
  </svg>
);